<template>
  <div class="fundo fill-height"
    :style="fundo">
  <v-container fixed fill-height >
    <v-layout row flex align-center justify-center>
      <v-flex xs12 sm6 class="elevation-12">
        <v-card>
          <v-card-media v-if="logoApp" :src="logoApp" height="120px" contain>
          </v-card-media>

        <v-card-text v-if="sucesso || mensagem">
          <h3 v-if="sucesso" class="title primary--text font-weight-light my-3">Solicitação feita com sucesso!</h3>
          <h4 class="primary--text font-weight-light my-3">{{mensagem}}</h4>
        </v-card-text>

        <v-card-text v-else-if="!emailCode && !usuario">
          <v-form validate ref="formEmail"  v-model="validEmail">
            <h3 class="title primary--text font-weight-light my-3">Solicitar Alteração de Senha</h3>

            <v-flex xs12>
              <v-text-field
                v-model="email"
                label="E-mail"
                placeholder="nome@email.com.br"
                :rules="emailRules"
                hint="Informe o e-mail da conta que deseja redefinir a senha"
                persistent-hint></v-text-field>
            </v-flex>

            <v-layout row class="mt-3">
              <v-spacer></v-spacer>
              <v-btn to="/login" color="secondary">cancelar</v-btn>
              <v-btn type="submit" :disabled="!validEmail" @click="solicitarAlteracao" color="primary">Enviar E-mail</v-btn>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-text v-if="emailCode && !emailCode.dataAlteracao">
          <v-form ref="form" v-model="valid"> 
            <v-layout row>
              <v-flex xs12>
                <h3 class="mb-3 title secondary--text font-weight-light">Defina sua nova senha de acesso.</h3>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                name="senha"
                label="Senha"
                id="senha"
                v-model="senha"
                required
                :rules="senhaRules"
                :append-icon="mostrarSenha ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (mostrarSenha = !mostrarSenha)"                
                :type="mostrarSenha ? 'password' : 'text'"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                name="confirmacaoPassword"
                label="Confirmação de Senha"
                id="confirmacaoPassword"
                v-model="csenha"
                required
                :rules="csenhaRules"
                :append-icon="mostrarSenha ? 'visibility' : 'visibility_off'"
                @click:append="() => (mostrarSenha = !mostrarSenha)"
                :type="mostrarSenha ? 'password' : 'text'"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="mt-3">
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid" color="primary" @click="trocarSenha"> Confirmar </v-btn>
            </v-layout>
          </v-form>          
        </v-card-text>       
        
        <v-card-text v-if="usuario && !emailCode">
          <v-form ref="form" v-model="validUsuario"> 
            <v-layout row>
              <v-flex xs12>
                <h3 class="mb-3 title secondary--text font-weight-light">Defina sua nova senha de acesso.</h3>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <v-text-field v-if="usuarioLogado && !usuarioLogado.email"
                  v-model="email"
                  label="E-mail"
                  placeholder="nome@email.com.br"
                  :rules="emailRules"
                  hint="Informe o e-mail da conta que deseja redefinir a senha"
                  persistent-hint></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <v-text-field
                name="password"
                label="Senha Atual"
                id="password"
                v-model="password"
                required
                :append-icon="mostrarSenha ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (mostrarSenha = !mostrarSenha)"                
                :type="mostrarSenha ? 'password' : 'text'"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                name="senha"
                label="Nova Senha"
                id="senha"
                v-model="senha"
                required
                :rules="senhaRules"
                :append-icon="mostrarSenha ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (mostrarSenha = !mostrarSenha)"                
                :type="mostrarSenha ? 'password' : 'text'"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                name="confirmacaoPassword"
                label="Confirmação de Nova Senha"
                id="confirmacaoPassword"
                v-model="csenha"
                required
                :rules="csenhaRules"
                :append-icon="mostrarSenha ? 'visibility' : 'visibility_off'"
                @click:append="() => (mostrarSenha = !mostrarSenha)"
                :type="mostrarSenha ? 'password' : 'text'"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="mt-3">
              <v-spacer></v-spacer>
              <v-btn :disabled="!validUsuario" color="primary" @click="trocarSenhaLogado"> Confirmar </v-btn>
            </v-layout>
          </v-form>          
        </v-card-text>         
      </v-card>
    </v-flex>
  </v-layout>

    <v-snackbar
      :timeout="timeoutAlerta"
      :color="tipoAlerta"
      v-model="snackbar">
      {{ textAlerta }}
      <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>
   
  </v-container>
  </div>
</template>

<script>
  import axios from 'axios'
  import color from 'color'

  export default {
    data () {
      return {
        username: '',
        password: '',
        validEmail: false,
        mostrarSenha: true,
        email: '',
        snackbar: false,
        tipoAlerta: '',
        textAlerta: '',
        senha: '',
        csenha: '',
        usuarioLogado: null,
        timeoutAlerta: 6000,
        sucesso: false,
        mensagem: '',
        valid: false,
        validUsuario: false,
        emailCode: false,
        senhaRules: [
          v => !!v || 'Senha obrigatória',
          v => (!!v && v.length >= 8) || 'A senha deve ter no mínimo 8 caracteres'
        ],
        csenhaRules: [
          v => !!v || 'Confirmação de Senha obrigatória',
          () => this.senha === this.csenha || 'As senhas devem ser iguais'
        ],
        emailRules: [
          v => !!v || 'E-mail é obrigatório',
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'E-mail deve ser válido'
          }
        ]
      }
    },
    watch: {
      email () { // newValue, oldValue
        this.$refs.formEmail.validate()
      }
    },
    methods: {
      loadModel () {
        var self = this
        if (this.$route.params.code) {
          axios.get(`/emailCode/${this.$route.params.code}`)
            .then(response => {
              self.emailCode = response.data
              if (self.emailCode.dataAlteracao) {
                self.mensagem = 'Senha alterada com sucesso!'
              }
            })
            .catch(error => {
              self.mensagem = error.response.data.message
            })
        }

        if (this.usuario) {
          axios.get(`/usuarioLogado`)
            .then(response => {
              self.usuarioLogado = response.data
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
      solicitarAlteracao () {
        var self = this
        axios.post('/emailCode', {email: this.email})
          .then(function (response) {
            console.log(response.data)
            self.mensagem = 'Verifique o e-mail e siga o procedimento para alteração da senha!'
            self.sucesso = true
          })
          .catch(e => {})
      },
      trocarSenha () {
        var self = this
        axios.defaults.headers.common['X-Auth-Token'] = ''
        let params = {senha: this.senha, csenha: this.csenha}
        axios.put(`/emailCode/${this.emailCode.id}`, params)
        .then(function (response) {
          console.log(response.data)
          // self.$router.push({path: '/login'})
          self.mensagem = 'Senha alterada com sucesso!'
        })
        .catch(e => {
          self.tipoAlerta = 'error'
          self.textAlerta = 'Erro durante a alteração da senha.'
          self.snackbar = true
        })
      },
      trocarSenhaLogado () {
        var self = this
        let params = {password: this.password, senha: this.senha, csenha: this.csenha}
        if (this.email) {
          params['email'] = this.email
        }
        axios.put('/updatePassword', params)
        .then(function (response) {
          console.log(response.data)
          self.$router.push({path: '/login'})
        })
        .catch(e => {
          self.tipoAlerta = 'error'
          self.textAlerta = 'Erro durante a alteração da senha.'
          self.snackbar = true
        })
      }
    },
    computed: {
      logoApp () {
        return this.$store.state.cabecalho.logo
      },
      fundo () {
        let cor = '#5e35b1'
        if (this.$store.state.cabecalho.cor) {
          cor = this.$store.state.cabecalho.cor
        }
        let cor1 = color(cor).alpha(1)
        let cor2 = color(cor).alpha(0.7)
        let cor3 = color(cor).alpha(1)
        return `background: linear-gradient(${cor1} 1%, ${cor2} 50%, ${cor3} 99%), center center, url(/static/bg_01.jpg);`
      },
      usuario () {
        return this.$store.state.userLogin // window.localStorage.getItem('user')
      }
    },
    created () {
      console.log('redirect ' + this.$route.query.redirect)
      this.loadModel()
    }
  }
</script>
<style>
  a { 
    text-decoration: none;
  }
  .card__media {
    padding: 10px;
  }
  .card__media__background {
    position: relative;
  }
  .fundo {
    background-repeat: no-repeat;
    background-size: cover !important;
  }
</style>



// WEBPACK FOOTER //
// RedefinirSenha.vue?40e5d279